export default __webpack_public_path__ + "static/blog-404-blog-desktop-528fda896bcba6acc67c27b1e0ff3b09.png";